import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const unitTranslations = {
  cubicm: "متر مكعب",
  cubickm: "كيلومتر مكعب",
  cubiccm: "سنتيمتر مكعب",
  cubicmm: "ميليمتر مكعب",
  liter: "لتر",
  milliliter: "مليلتر",
  usgallon: "جالون أمريكي",
  usquart: "ربع جالون أمريكي",
  uspint: "نصف لتر أمريكي",
  uscup: "كوب أمريكي",
  usfluidounce: "أونصة سائلة أمريكية",
  ustablespoon: "ملعقة كبيرة أمريكية",
  usteaspoon: "ملعقة صغيرة أمريكية",
  imperialgallon: "جالون إمبراطوري",
  imperialquart: "ربع جالون إمبراطوري",
  imperialpint: "نصف لتر إمبراطوري",
  imperialfluidounce: "أونصة سائلة إمبراطورية",
  imperialtablespoon: "ملعقة كبيرة إمبراطورية",
  imperialteaspoon: "ملعقة صغيرة إمبراطورية",
  cubicmile: "ميل مكعب",
  cubicyard: "ياردة مكعبة",
  cubicfoot: "قدم مكعب",
  cubicinch: "بوصة مكعبة",
};
const conversionRates = {
  cubicm: {
    cubicm: 1,
    cubickm: 1e-9,
    cubiccm: 1e6,
    cubicmm: 1e9,
    liter: 1000,
    milliliter: 1e6,
    usgallon: 264.172,
    usquart: 1056.69,
    uspint: 2113.38,
    uscup: 4226.75,
    usfluidounce: 33814,
    ustablespoon: 67628,
    usteaspoon: 202884,
    imperialgallon: 219.969,
    imperialquart: 879.877,
    imperialpint: 1759.75,
    imperialfluidounce: 35195.1,
    imperialtablespoon: 56312,
    imperialteaspoon: 168936,
    cubicmile: 2.39913e-10,
    cubicyard: 1.30795,
    cubicfoot: 35.3147,
    cubicinch: 61023.7,
  },
  cubickm: {
    cubicm: 1e9,
    cubickm: 1,
    cubiccm: 1e15,
    cubicmm: 1e18,
    liter: 1e12,
    milliliter: 1e15,
    usgallon: 2.64172e11,
    usquart: 1.05669e12,
    uspint: 2.11338e12,
    uscup: 4.22675e12,
    usfluidounce: 3.3814e13,
    ustablespoon: 6.7628e13,
    usteaspoon: 2.02884e14,
    imperialgallon: 2.19969e11,
    imperialquart: 8.79877e11,
    imperialpint: 1.75975e12,
    imperialfluidounce: 3.51951e13,
    imperialtablespoon: 5.6312e13,
    imperialteaspoon: 1.68936e14,
    cubicmile: 2.39913e-1,
    cubicyard: 1.30795e9,
    cubicfoot: 3.53147e10,
    cubicinch: 6.10237e13,
  },
  cubiccm: {
    cubicm: 1e-6,
    cubickm: 1e-15,
    cubiccm: 1,
    cubicmm: 1000,
    liter: 0.001,
    milliliter: 1,
    usgallon: 0.000264172,
    usquart: 0.00105669,
    uspint: 0.00211338,
    uscup: 0.00422675,
    usfluidounce: 0.033814,
    ustablespoon: 0.067628,
    usteaspoon: 0.202884,
    imperialgallon: 0.000219969,
    imperialquart: 0.000879877,
    imperialpint: 0.00175975,
    imperialfluidounce: 0.0351951,
    imperialtablespoon: 0.056312,
    imperialteaspoon: 0.168936,
    cubicmile: 2.39913e-19,
    cubicyard: 1.30795e-6,
    cubicfoot: 3.53147e-5,
    cubicinch: 0.0610237,
  },
  cubicmm: {
    cubicm: 1e-9,
    cubickm: 1e-18,
    cubiccm: 0.001,
    cubicmm: 1,
    liter: 1e-6,
    milliliter: 0.001,
    usgallon: 2.64172e-7,
    usquart: 1.05669e-6,
    uspint: 2.11338e-6,
    uscup: 4.22675e-6,
    usfluidounce: 3.3814e-5,
    ustablespoon: 6.7628e-5,
    usteaspoon: 0.000202884,
    imperialgallon: 2.19969e-7,
    imperialquart: 8.79877e-7,
    imperialpint: 1.75975e-6,
    imperialfluidounce: 3.51951e-5,
    imperialtablespoon: 5.6312e-5,
    imperialteaspoon: 0.000168936,
    cubicmile: 2.39913e-22,
    cubicyard: 1.30795e-9,
    cubicfoot: 3.53147e-8,
    cubicinch: 6.10237e-5,
  },
  liter: {
    cubicm: 0.001,
    cubickm: 1e-12,
    cubiccm: 1000,
    cubicmm: 1e6,
    liter: 1,
    milliliter: 1000,
    usgallon: 0.264172,
    usquart: 1.05669,
    uspint: 2.11338,
    uscup: 4.22675,
    usfluidounce: 33.814,
    ustablespoon: 67.628,
    usteaspoon: 202.884,
    imperialgallon: 0.219969,
    imperialquart: 0.879877,
    imperialpint: 1.75975,
    imperialfluidounce: 35.1951,
    imperialtablespoon: 56.312,
    imperialteaspoon: 168.936,
    cubicmile: 2.39913e-13,
    cubicyard: 0.00130795,
    cubicfoot: 0.0353147,
    cubicinch: 61.0237,
  },
  milliliter: {
    cubicm: 1e-6,
    cubickm: 1e-15,
    cubiccm: 1,
    cubicmm: 1000,
    liter: 0.001,
    milliliter: 1,
    usgallon: 0.000264172,
    usquart: 0.00105669,
    uspint: 0.00211338,
    uscup: 0.00422675,
    usfluidounce: 0.033814,
    ustablespoon: 0.067628,
    usteaspoon: 0.202884,
    imperialgallon: 0.000219969,
    imperialquart: 0.000879877,
    imperialpint: 0.00175975,
    imperialfluidounce: 0.0351951,
    imperialtablespoon: 0.056312,
    imperialteaspoon: 0.168936,
    cubicmile: 2.39913e-19,
    cubicyard: 1.30795e-6,
    cubicfoot: 3.53147e-5,
    cubicinch: 0.0610237,
  },
  usgallon: {
    cubicm: 0.00378541,
    cubickm: 3.78541e-12,
    cubiccm: 3785.41,
    cubicmm: 3.78541e6,
    liter: 3.78541,
    milliliter: 3785.41,
    usgallon: 1,
    usquart: 4,
    uspint: 8,
    uscup: 16,
    usfluidounce: 128,
    ustablespoon: 256,
    usteaspoon: 768,
    imperialgallon: 0.832674,
    imperialquart: 3.3307,
    imperialpint: 6.66139,
    imperialfluidounce: 133.228,
    imperialtablespoon: 213.165,
    imperialteaspoon: 639.494,
    cubicmile: 9.08169e-13,
    cubicyard: 0.00495113,
    cubicfoot: 0.133681,
    cubicinch: 231,
  },
  usquart: {
    cubicm: 0.000946353,
    cubickm: 9.46353e-13,
    cubiccm: 946.353,
    cubicmm: 946353,
    liter: 0.946353,
    milliliter: 946.353,
    usgallon: 0.25,
    usquart: 1,
    uspint: 2,
    uscup: 4,
    usfluidounce: 32,
    ustablespoon: 64,
    usteaspoon: 192,
    imperialgallon: 0.208168,
    imperialquart: 0.832674,
    imperialpint: 1.66535,
    imperialfluidounce: 33.3069,
    imperialtablespoon: 53.291,
    imperialteaspoon: 159.873,
    cubicmile: 2.27042e-13,
    cubicyard: 0.00123778,
    cubicfoot: 0.0334201,
    cubicinch: 57.75,
  },
  uspint: {
    cubicm: 0.000473176,
    cubickm: 4.73176e-13,
    cubiccm: 473.176,
    cubicmm: 473176,
    liter: 0.473176,
    milliliter: 473.176,
    usgallon: 0.125,
    usquart: 0.5,
    uspint: 1,
    uscup: 2,
    usfluidounce: 16,
    ustablespoon: 32,
    usteaspoon: 96,
    imperialgallon: 0.104084,
    imperialquart: 0.416337,
    imperialpint: 0.832674,
    imperialfluidounce: 16.6535,
    imperialtablespoon: 26.6455,
    imperialteaspoon: 79.9367,
    cubicmile: 1.13521e-13,
    cubicyard: 0.000618891,
    cubicfoot: 0.0167101,
    cubicinch: 28.875,
  },
  uscup: {
    cubicm: 0.000236588,
    cubickm: 2.36588e-13,
    cubiccm: 236.588,
    cubicmm: 236588,
    liter: 0.236588,
    milliliter: 236.588,
    usgallon: 0.0625,
    usquart: 0.25,
    uspint: 0.5,
    uscup: 1,
    usfluidounce: 8,
    ustablespoon: 16,
    usteaspoon: 48,
    imperialgallon: 0.0520421,
    imperialquart: 0.208168,
    imperialpint: 0.416337,
    imperialfluidounce: 8.32674,
    imperialtablespoon: 13.3228,
    imperialteaspoon: 39.9683,
    cubicmile: 5.67603e-14,
    cubicyard: 0.000309446,
    cubicfoot: 0.00835503,
    cubicinch: 14.4375,
  },
  usfluidounce: {
    cubicm: 2.9574e-5,
    cubickm: 2.9574e-14,
    cubiccm: 29.5735,
    cubicmm: 29573.5,
    liter: 0.0295735,
    milliliter: 29.5735,
    usgallon: 0.0078125,
    usquart: 0.03125,
    uspint: 0.0625,
    uscup: 0.125,
    usfluidounce: 1,
    ustablespoon: 2,
    usteaspoon: 6,
    imperialgallon: 0.00650527,
    imperialquart: 0.0260211,
    imperialpint: 0.0520421,
    imperialfluidounce: 1.04084,
    imperialtablespoon: 1.66535,
    imperialteaspoon: 4.99602,
    cubicmile: 7.09504e-15,
    cubicyard: 3.86832e-5,
    cubicfoot: 0.00104438,
    cubicinch: 1.80469,
  },
  ustablespoon: {
    cubicm: 1.47868e-5,
    cubickm: 1.47868e-14,
    cubiccm: 14.7868,
    cubicmm: 14786.8,
    liter: 0.0147868,
    milliliter: 14.7868,
    usgallon: 0.00390625,
    usquart: 0.015625,
    uspint: 0.03125,
    uscup: 0.0625,
    usfluidounce: 0.5,
    ustablespoon: 1,
    usteaspoon: 3,
    imperialgallon: 0.00325263,
    imperialquart: 0.0130105,
    imperialpint: 0.0260211,
    imperialfluidounce: 0.520421,
    imperialtablespoon: 0.832674,
    imperialteaspoon: 2.49801,
    cubicmile: 3.54752e-15,
    cubicyard: 1.93416e-5,
    cubicfoot: 0.00052219,
    cubicinch: 0.902344,
  },
  usteaspoon: {
    cubicm: 4.92892e-6,
    cubickm: 4.92892e-15,
    cubiccm: 4.92892,
    cubicmm: 4928.92,
    liter: 0.00492892,
    milliliter: 4.92892,
    usgallon: 0.00130208,
    usquart: 0.00520833,
    uspint: 0.0104167,
    uscup: 0.0208333,
    usfluidounce: 0.166667,
    ustablespoon: 0.333333,
    usteaspoon: 1,
    imperialgallon: 0.00108421,
    imperialquart: 0.00433684,
    imperialpint: 0.00867369,
    imperialfluidounce: 0.173474,
    imperialtablespoon: 0.277558,
    imperialteaspoon: 0.832674,
    cubicmile: 1.18251e-15,
    cubicyard: 6.44721e-6,
    cubicfoot: 0.000173772,
    cubicinch: 0.300781,
  },
  imperialgallon: {
    cubicm: 0.00454609,
    cubickm: 4.54609e-12,
    cubiccm: 4546.09,
    cubicmm: 4.54609e6,
    liter: 4.54609,
    milliliter: 4546.09,
    usgallon: 1.20095,
    usquart: 4.8038,
    uspint: 9.6076,
    uscup: 19.2152,
    usfluidounce: 153.722,
    ustablespoon: 307.443,
    usteaspoon: 922.33,
    imperialgallon: 1,
    imperialquart: 4,
    imperialpint: 8,
    imperialfluidounce: 160,
    imperialtablespoon: 256,
    imperialteaspoon: 768,
    cubicmile: 1.09017e-12,
    cubicyard: 0.00594606,
    cubicfoot: 0.160544,
    cubicinch: 277.419,
  },
  imperialquart: {
    cubicm: 0.00113652,
    cubickm: 1.13652e-12,
    cubiccm: 1136.52,
    cubicmm: 1.13652e6,
    liter: 1.13652,
    milliliter: 1136.52,
    usgallon: 0.300237,
    usquart: 1.20095,
    uspint: 2.4019,
    uscup: 4.8038,
    usfluidounce: 38.4304,
    ustablespoon: 76.8608,
    usteaspoon: 230.583,
    imperialgallon: 0.25,
    imperialquart: 1,
    imperialpint: 2,
    imperialfluidounce: 40,
    imperialtablespoon: 64,
    imperialteaspoon: 192,
    cubicmile: 2.72543e-13,
    cubicyard: 0.00148651,
    cubicfoot: 0.040136,
    cubicinch: 69.3548,
  },
  imperialpint: {
    cubicm: 0.000568261,
    cubickm: 5.68261e-13,
    cubiccm: 568.261,
    cubicmm: 568261,
    liter: 0.568261,
    milliliter: 568.261,
    usgallon: 0.150118,
    usquart: 0.600475,
    uspint: 1.20095,
    uscup: 2.4019,
    usfluidounce: 19.2152,
    ustablespoon: 38.4304,
    usteaspoon: 115.291,
    imperialgallon: 0.125,
    imperialquart: 0.5,
    imperialpint: 1,
    imperialfluidounce: 20,
    imperialtablespoon: 32,
    imperialteaspoon: 96,
    cubicmile: 1.36272e-13,
    cubicyard: 0.000743255,
    cubicfoot: 0.020068,
    cubicinch: 34.6774,
  },
  imperialfluidounce: {
    cubicm: 2.84131e-5,
    cubickm: 2.84131e-14,
    cubiccm: 28.4131,
    cubicmm: 28413.1,
    liter: 0.0284131,
    milliliter: 28.4131,
    usgallon: 0.00750594,
    usquart: 0.0300237,
    uspint: 0.0600475,
    uscup: 0.120095,
    usfluidounce: 0.96076,
    ustablespoon: 1.92152,
    usteaspoon: 5.76457,
    imperialgallon: 0.00625,
    imperialquart: 0.025,
    imperialpint: 0.05,
    imperialfluidounce: 1,
    imperialtablespoon: 1.6,
    imperialteaspoon: 4.8,
    cubicmile: 6.81358e-15,
    cubicyard: 0.0000371628,
    cubicfoot: 0.00010034,
    cubicinch: 1.73387,
  },
  imperialtablespoon: {
    cubicm: 1.77582e-5,
    cubickm: 1.77582e-14,
    cubiccm: 17.7582,
    cubicmm: 17758.2,
    liter: 0.0177582,
    milliliter: 17.7582,
    usgallon: 0.00469121,
    usquart: 0.0187648,
    uspint: 0.0375295,
    uscup: 0.0750594,
    usfluidounce: 0.600475,
    ustablespoon: 1.20095,
    usteaspoon: 3.60284,
    imperialgallon: 0.00390625,
    imperialquart: 0.015625,
    imperialpint: 0.03125,
    imperialfluidounce: 0.625,
    imperialtablespoon: 1,
    imperialteaspoon: 3,
    cubicmile: 4.25848e-15,
    cubicyard: 0.0000232268,
    cubicfoot: 0.0000627125,
    cubicinch: 1.08367,
  },
  imperialteaspoon: {
    cubicm: 5.91939e-6,
    cubickm: 5.91939e-15,
    cubiccm: 5.91939,
    cubicmm: 5919.39,
    liter: 0.00591939,
    milliliter: 5.91939,
    usgallon: 0.00156374,
    usquart: 0.00625496,
    uspint: 0.0125099,
    uscup: 0.0250197,
    usfluidounce: 0.200158,
    ustablespoon: 0.400317,
    usteaspoon: 1.20095,
    imperialgallon: 0.00130208,
    imperialquart: 0.00520833,
    imperialpint: 0.0104167,
    imperialfluidounce: 0.208333,
    imperialtablespoon: 0.333333,
    imperialteaspoon: 1,
    cubicmile: 1.41949e-15,
    cubicyard: 7.74227e-6,
    cubicfoot: 0.0000209042,
    cubicinch: 0.361224,
  },
  cubicmile: {
    cubicm: 4.16818e9,
    cubickm: 4.16818,
    cubiccm: 4.16818e15,
    cubicmm: 4.16818e18,
    liter: 4.16818e12,
    milliliter: 4.16818e15,
    usgallon: 1.10161e12,
    usquart: 4.40645e12,
    uspint: 8.8129e12,
    uscup: 1.76258e13,
    usfluidounce: 1.41007e14,
    ustablespoon: 2.82013e14,
    usteaspoon: 8.46039e14,
    imperialgallon: 9.05525e11,
    imperialquart: 3.6221e12,
    imperialpint: 7.2442e12,
    imperialfluidounce: 1.44884e14,
    imperialtablespoon: 2.31814e14,
    imperialteaspoon: 6.95442e14,
    cubicmile: 1,
    cubicyard: 5.45147e9,
    cubicfoot: 1.47198e11,
    cubicinch: 2.5457e14,
  },
  cubicyard: {
    cubicm: 0.764555,
    cubickm: 7.64555e-10,
    cubiccm: 764555,
    cubicmm: 7.64555e8,
    liter: 764.555,
    milliliter: 764555,
    usgallon: 201.974,
    usquart: 807.897,
    uspint: 1615.79,
    uscup: 3231.59,
    usfluidounce: 25852.7,
    ustablespoon: 51705.4,
    usteaspoon: 155116,
    imperialgallon: 168.179,
    imperialquart: 672.716,
    imperialpint: 1345.43,
    imperialfluidounce: 26908.6,
    imperialtablespoon: 43054,
    imperialteaspoon: 129162,
    cubicmile: 1.83427e-10,
    cubicyard: 1,
    cubicfoot: 27,
    cubicinch: 46656,
  },
  cubicfoot: {
    cubicm: 0.0283168,
    cubickm: 2.83168e-11,
    cubiccm: 28316.8,
    cubicmm: 2.83168e7,
    liter: 28.3168,
    milliliter: 28316.8,
    usgallon: 7.48052,
    usquart: 29.9221,
    uspint: 59.8442,
    uscup: 119.688,
    usfluidounce: 957.506,
    ustablespoon: 1915.01,
    usteaspoon: 5745.03,
    imperialgallon: 6.22884,
    imperialquart: 24.9154,
    imperialpint: 49.8308,
    imperialfluidounce: 996.616,
    imperialtablespoon: 1594.59,
    imperialteaspoon: 4783.78,
    cubicmile: 6.79357e-12,
    cubicyard: 0.037037,
    cubicfoot: 1,
    cubicinch: 1728,
  },
  cubicinch: {
    cubicm: 1.63871e-5,
    cubickm: 1.63871e-14,
    cubiccm: 16.3871,
    cubicmm: 16387.1,
    liter: 0.0163871,
    milliliter: 16.3871,
    usgallon: 0.004329,
    usquart: 0.017316,
    uspint: 0.034632,
    uscup: 0.0692641,
    usfluidounce: 0.554113,
    ustablespoon: 1.10823,
    usteaspoon: 3.32468,
    imperialgallon: 0.00360465,
    imperialquart: 0.0144186,
    imperialpint: 0.0288372,
    imperialfluidounce: 0.576744,
    imperialtablespoon: 0.922791,
    imperialteaspoon: 2.76837,
    cubicmile: 3.93147e-15,
    cubicyard: 2.14335e-5,
    cubicfoot: 0.000578704,
    cubicinch: 1,
  },
};
function VolumeConverter() {
  const { fromVolumeUnit, toVolumeUnit } = useParams();
  const [amount, setAmount] = useState(1);
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [storedAmount, setStoredAmount] = useState("");
  const translatedFromUnit = unitTranslations[fromVolumeUnit] || fromVolumeUnit;
  const translatedToUnit = unitTranslations[toVolumeUnit] || toVolumeUnit;
  const TITLE = `تحويل من ${translatedFromUnit} إلى ${translatedToUnit}`;
  const DESCRIPTION = `استخدم محول الوحدات المتقدم لدينا لتحويل دقيق بين ${translatedFromUnit} و${translatedToUnit}. قم بحساب وتحويل كميات ${translatedFromUnit} إلى ${translatedToUnit} بسرعة وسهولة باستخدام أدوات التحويل الفعالة لدينا. مثالي لتحويل الوحدات في الحسابات اليومية والاحترافية.`;
  const KEYWORDS = `تحويل وحدات, ${translatedFromUnit} إلى ${translatedToUnit}, ${fromVolumeUnit} إلى ${toVolumeUnit}, محول وحدات, أدوات تحويل`;
  const OG_URL = `https://do-calculate.com/calculator/ar/unit_converter/volume/${fromVolumeUnit}/${toVolumeUnit}`;
  useEffect(() => {
    setConvertedAmount(null);
  }, [fromVolumeUnit, toVolumeUnit]);
  const handleCalculate = () => {
    if (
      amount &&
      conversionRates[fromVolumeUnit] &&
      conversionRates[fromVolumeUnit][toVolumeUnit]
    ) {
      setStoredAmount(amount);
      const result = amount * conversionRates[fromVolumeUnit][toVolumeUnit];
      setConvertedAmount(result);
    } else {
      setConvertedAmount("0");
    }
  };
  const amounts = [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000];
  amounts.sort((a, b) => a - b);
  const conversionTable = amounts.map((a) => ({
    fromAmount: a,
    toAmount: a * conversionRates[fromVolumeUnit][toVolumeUnit],
  }));
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بك في أداة <strong>تحويل الوحدات</strong> الرائدة
                  لدينا! مع <strong>محول الوحدات</strong> هذا، يمكنك بسهولة
                  تحويل الوحدات من <strong>{translatedFromUnit}</strong> إلى{" "}
                  <strong>{translatedToUnit}</strong> والعكس. هل تحتاج إلى{" "}
                  <strong>
                    تحويل {translatedFromUnit} إلى {translatedToUnit}
                  </strong>
                  ؟ أو ربما{" "}
                  <strong>
                    تحويل {translatedToUnit} إلى {translatedFromUnit}
                  </strong>
                  ؟ هذه الأداة توفر لك الحل المثالي. استخدم{" "}
                  <strong>محول الوحدات</strong> لتحويل مقادير{" "}
                  <strong>{translatedFromUnit}</strong> إلى{" "}
                  <strong>{translatedToUnit}</strong> بدقة وسرعة، أو العكس،
                  لتحصل على النتائج التي تحتاجها. سواء كنت بحاجة إلى{" "}
                  <strong>تحويل {translatedFromUnit}</strong> إلى{" "}
                  <strong>{translatedToUnit}</strong> لأغراض مختلفة، فمحول
                  الوحدات هذا هو الأداة المثالية لذلك.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    {translatedFromUnit} إلى {translatedToUnit}
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="alert alert-info">
                      <b>1 </b> {translatedFromUnit} يساوي{" "}
                      <b>{1 * conversionRates[fromVolumeUnit][toVolumeUnit]}</b>{" "}
                      {translatedToUnit}
                      <br />
                    </div>
                    <hr />
                    <div
                      className="form-group d-flex align-items-center"
                      htmlFor="amount"
                    >
                      <b>
                        <label className="form-label ms-2">
                          ادخل القيمة بالـ {translatedFromUnit}
                        </label>
                      </b>
                      <input
                        id="amount"
                        type="number"
                        value={amount}
                        onChange={(e) =>
                          setAmount(parseFloat(e.target.value) || 0)
                        }
                        placeholder="أدخل القيمة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <Link
                      to={`/calculator/ar/unit_converter/volume/${toVolumeUnit}/${fromVolumeUnit}/`}
                    >
                      <button
                        className="text-white bg-secondary"
                        style={{ padding: "4px" }}
                      >
                        تحويل من {translatedToUnit} إلى {translatedFromUnit}
                      </button>
                    </Link>
                  </div>
                  <br />
                  {convertedAmount &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p className="text-white">
                        {storedAmount} {translatedFromUnit} = {convertedAmount}{" "}
                        {translatedToUnit}{" "}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
              <div>
                <br />
                <p className="alert alert-success">
                  ان كل <b>1 (واحد)</b> {translatedFromUnit} يساوي{" "}
                  <b>{1 * conversionRates[fromVolumeUnit][toVolumeUnit]}</b>{" "}
                  {translatedToUnit} وفيما يلي جدول يظهر السعر لبعض الفئات:
                </p>
                <table >
                  <thead>
                    <tr>
                      <th >{translatedFromUnit}</th>
                      <th >{translatedToUnit}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {conversionTable.map((entry, index) => (
                      <tr key={index}>
                        <td>
                          {entry.fromAmount} {translatedFromUnit}
                        </td>
                        <td>
                          {entry.toAmount} {translatedToUnit}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <MainCalculatorsList></MainCalculatorsList>
          <br/>        </div>
         </div>
</div>
  );
}
export default VolumeConverter;
